export default class FactoryAuditState {
  constructor() {
    // GET Item List
    this.itemList = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Detail Item
    this.detailItem = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Quote List (by itemId)
    this.quoteListItemDetail = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Quote (by itemId and quoteId)
    this.quoteItemDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Report (by itemId)
    this.reportItemDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Quote Attachment (by itemId and quoteId)
    this.quoteAttachmentItemDetail = {
      loading: false,
      data: {}, // zip file
      error: null,
    };

    // GET Quote Attachment (by itemId and reportId)
    this.reportAttachmentItemDetail = {
      loading: false,
      data: {}, // zip file
      error: null,
    };

    // GET Invoice List (by invoiceId)
    this.invoiceItemDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Invoice List (by itemId)
    this.invoiceListItemDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Invoice Downloaded File
    this.invoiceDownloadedListItemDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Service Provider List
    this.serviceProviderList = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Payer List
    this.payerList = {
      loading: false,
      data: [],
      error: null,
    };
  }
}
